import { useEffect } from 'react';
import styled from 'styled-components';

import {
  CollectionActions,
  CollectionSelectors,
  WalletSelectors,
} from '@store';
import { Box, Loading, Text } from '@components/common';
import { useAppDispatch, useAppSelector } from '@hooks';
import { MysteryForestImage } from '@src/client/assets/images';

const Background = styled(Box)`
  background-image: ${`url(${MysteryForestImage})`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

const StyledImg = styled.img`
  &&& {
    width: 500px;
    height: 500px;
  }
`;

export const Collection = () => {
  const dispatch = useAppDispatch();
  const selectedAddress = useAppSelector(WalletSelectors.selectSelectedAddress);
  const collectionState = useAppSelector(
    CollectionSelectors.selectCollectionState
  );

  useEffect(() => {
    if (selectedAddress) {
      dispatch(CollectionActions.getCollection());
    }
  }, [selectedAddress]);

  return (
    <Background center flex={1}>
      {collectionState.isLoading && <Loading />}
      {!collectionState.isLoading &&
        collectionState.current.map((nft) => (
          <Box key={nft.tokenId} py={3}>
            <StyledImg
              key={nft.tokenId}
              src={nft.tokenUri.image}
              alt={nft.tokenId.toString()}
            />
            <Text
              fontFamily="Caveat"
              fontSize={36}
              textAlign="center"
              fontWeight="bold"
              color="info"
            >
              {nft.tokenId}
            </Text>
          </Box>
        ))}
    </Background>
  );
};
